/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useState, useEffect } from 'react';
import $ from 'jquery';
import '../modals.scss';
import CloseButton from '../../Buttons/CloseButton';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../assets/constants/strings';
import { connect } from 'react-redux';
import SubscriptionFrame from '../../RightNav/SubscriptionFrame';
import moment from 'moment';

const VersioningModal = ({
  user,
  onDismiss,
  currentDocument,
  previousDocument,
  handleComparison,
}) => {
  const [displayList, setDisplayList] = useState(null);
  const [showSubFrame, setShowSubFrame] = useState(false);

  useEffect(() => {
    $('#versioningModal').on('hide.bs.modal', () => {
      setDisplayList(null);
      onDismiss(false);
    });
  }, []);

  useEffect(() => {
    if (currentDocument !== null && previousDocument !== null && !displayList) {
      assembleDisplayList();
    }
  }, [currentDocument, previousDocument]);

  const assembleDisplayList = () => {
    // for now, we only display immediate previous version,
    // but for future implementation, just keep adding
    // to this list to show even older versions
    setDisplayList([
      { ...currentDocument, headerCell: 'Current Version' },
      { ...previousDocument, headerCell: 'Previous Version' },
    ]);
  };

  const onComparisonClick = () => {
    handleComparison(previousDocument);
    onDismiss();
  };

  const checkRestriction = () => {
    if (user && user.restriction > 1 && !showSubFrame) {
      setShowSubFrame(true);
    } else {
      setShowSubFrame(false);
    }
  };

  return (
    <div
      className='modal w-100 versioning-modal'
      id='versioningModal'
      role='dialog'
      aria-hidden='true'
    >
      <div
        className='modal-dialog modal-dialog-centered modal-lg'
        role='document'
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <div className='modal-title'>
              <h3 className='font-weight-bold mb-0'>
                {currentDocument && currentDocument.title
                  ? currentDocument.title
                  : 'Previous Version'}
              </h3>
            </div>
            <CloseButton white title='Dismiss Modal' handleClose={onDismiss} />
          </div>
          {displayList && currentDocument && previousDocument && (
            <div className='modal-body versioning-modal__body'>
              {/* first row, justify at the end */}
              <div className='versioning-modal__body__row header-row'>
                <span>Version Date</span>
                <span>Registration Date</span>
              </div>
              {displayList.map((document, i) => (
                <div className='versioning-modal__body__row' key={i}>
                  <span className='header-cell'>{document.headerCell}</span>
                  <span>
                    {document.versionDate
                      ? moment(document.versionDate).format('DD MMM YYYY')
                      : '-'}
                  </span>
                  <span>
                    {document.registrationDate
                      ? moment(document.registrationDate).format('DD MMM YYYY')
                      : '-'}
                  </span>
                </div>
              ))}
              <div
                className='versioning-modal__body__actions'
                onMouseEnter={checkRestriction}
                onMouseLeave={checkRestriction}
              >
                {showSubFrame ? (
                  <SubscriptionFrame />
                ) : (
                  <React.Fragment>
                    {user && user.restriction > 1 ? (
                      <button
                        className='my-account-btn terciary disabled'
                        onClick={null}
                      >
                        View Previous Version
                      </button>
                    ) : (
                      <Link
                        className='my-account-btn terciary'
                        to={ROUTES.DOCUMENT(previousDocument.slug)}
                        target='_blank'
                        rel='noreferrer'
                        onClick={onDismiss}
                      >
                        View Previous Version
                      </Link>
                    )}
                    {/* <button
                      className={`my-account-btn terciary${
                        user && user.restriction > 1 ? ' disabled' : ''
                      }`}
                      onClick={
                        user && user.restriction > 1 ? null : onComparisonClick
                      }
                    >
                      Compare Versions
                    </button> */}
                  </React.Fragment>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps)(VersioningModal);
